<template>
    <div class="container" v-loading="repLoading">
        <div v-if="!showInner">
            <div class="flex_space_between search_box">
                <div class="flex_start">
                    <div class="flex_start_center mr_24">
                        <div class="mr_12">患者姓名：</div>
                        <div>
                            <el-input placeholder="请输入" v-model="searchForm.name"></el-input>
                        </div>
                    </div>
                    <el-button type="primary" @click="search">搜索</el-button>
                    <el-button type="warning" @click="reset">重置</el-button>
                </div>
            </div>

            <div class="huanz_list" v-if="list.length != 0" :image-size="200">
                <div :class="`item ${key % 4 == 0 ? 'item_l' : ''}`" v-for="(val, key) in list" :key="key">
                    <div :class="`item_title ${val.bind == 1 ? '' : 'item_title_red'}`" class="flex_space_between">
                        <div class="num">{{ val.bed_number }}</div>
                        <div class="flex_start" style="gap:10px">
                            <div class="report_btn" @click="handleSleepReport(val)" v-show="val.bind == 1">睡眠报告</div>
                            <div class="report_btn" @click="handleActivityDialog(val)" v-show="val.bind == 1">活动统计</div>
                        </div>
                    </div>
                    <div class="item_box">
                        <div class="item_name">{{ val.name }}</div>
                        <div class="item_btn" v-if="val.bind == 1" @click="yibindVisiblebor(val)">
                            设备已绑定
                        </div>
                        <div class="item_btn red" @click="bindVisiblebor(val)" v-else>
                            设备未绑定
                        </div>
                    </div>
                </div>
            </div>

            <el-empty v-if="list.length == 0" description="暂无数据" style="margin-top: 5%;"></el-empty>
            <el-dialog :visible.sync="bindVisible" title="绑定设备" width="740px">
                <div class="_bindList">
                    <el-table :data="bindList" v-loading="repLoading" align="center" border>
                        <el-table-column prop="ccid" label="设备CCID号" align="center"></el-table-column>
                        <el-table-column prop="status" label="状态" align="center">
                            <template slot-scope="scope">
                                <div :class="`_bindList_text${scope.row.bind}`">
                                    {{ scope.row.bind == 1 ? '已绑定' : '未绑定' }}
                                    {{ scope.row.bind == 1 ? scope.row.bed_number : '' }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="160">
                            <template slot-scope="scope">
                                <el-button plain type="info" size="small" v-if="scope.row.bind == 1" disabled
                                    color="#9296AF">已绑定</el-button>
                                <el-button plain type="danger" size="small" v-else
                                    @click="patient_bind(scope.row)">绑定</el-button>

                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-dialog>

            <el-dialog :visible.sync="setConfigDialog" v-loading="figsLoading" :title="configDisabledTitle"
                width="740px">
                <div class="set_config_box">
                    <el-form :model="configSetForm" v-loading="figsLoading" :disabled="configDisabled"
                        :rules="configSetFormRules" ref="configSetForm" class="config_set_form" label-width="140px"
                        label-position="left">
                        <div class="config_type_title">心率预警阈值</div>
                        <el-form-item prop="high_heartrate_value" label="最高值（bpm）：">
                            <el-input size="mini" class="el_input" placeholder="请输入"
                                v-model="configSetForm.high_heartrate_value"></el-input>
                            <span style="margin:0 5px;">持续</span>
                            <el-select placeholder="请选择" v-model="configSetForm.high_heartrate_time" size="mini">
                                <el-option label="立即" v-if="affter == 2" :value="1"></el-option>
                                <el-option label="10分钟" :value="10"></el-option>
                                <el-option label="20分钟" :value="20"></el-option>
                                <el-option label="30分钟" :value="30"></el-option>
                            </el-select>
                            <span style="margin:0 5px;">高心率预警</span>
                        </el-form-item>
                        <el-form-item prop="low_heartrate_value" label="最低值（bpm）：">
                            <el-input size="mini" class="el_input" placeholder="请输入"
                                v-model="configSetForm.low_heartrate_value"></el-input>
                            <span style="margin:0 5px;">持续</span>
                            <el-select placeholder="请选择" v-model="configSetForm.low_heartrate_time" size="mini">
                                <el-option label="立即" v-if="affter == 2" :value="1"></el-option>
                                <el-option label="10分钟" :value="10"></el-option>
                                <el-option label="20分钟" :value="20"></el-option>
                                <el-option label="30分钟" :value="30"></el-option>
                            </el-select>
                            <span style="margin:0 5px;">低心率预警</span>
                        </el-form-item>
                        <div class="config_type_title mt_20">血氧预警阈值</div>
                        <el-form-item prop="spo2" label="最低值（%）：">
                            <el-input size="mini" class="el_input" placeholder="请输入"
                                v-model="configSetForm.spo2"></el-input>
                            <span style="margin:0 5px;">持续</span>
                            <el-select placeholder="请选择" v-model="configSetForm.low_spo_time" size="mini">
                                <el-option label="立即" v-if="affter == 2" :value="1"></el-option>
                                <el-option label="10分钟" :value="10"></el-option>
                                <el-option label="20分钟" :value="20"></el-option>
                                <el-option label="30分钟" :value="30"></el-option>
                            </el-select>
                            <span style="margin:0 5px;">低血氧预警</span>
                        </el-form-item>
                        <div class="config_type_title mt_20">数据频率设置</div>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item prop="ppg" label="采集频率：" label-width="auto">
                                    <div>{{  uploadFrequency  }}</div>
                                    <!-- <el-select placeholder="请选择" v-model="configSetForm.ppg" size="mini">
                                        <el-option v-for="(item, index) in ppg_list" :key="index" :label="item.label"
                                            :value="item.value"></el-option>
                                    </el-select> -->
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="normal_rate" label="上传频率：" label-width="auto">
                                    <el-select placeholder="请选择" v-model="configSetForm.normal_rate" size="mini"
                                        v-if="configSetForm.ppg == 300">
                                        <el-option v-for="(item, index) in normal_rate_list_1" :key="index"
                                            :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                    <el-select placeholder="请选择" v-model="configSetForm.normal_rate" size="mini" v-else>
                                        <el-option v-for="(item, index) in normal_rate_list_2" :key="index"
                                            :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <span slot="footer" v-if="!configDisabled" class="dialog-footer">
                    <div class="config_tips">设置阈值及频率后,可通过重启立即更新</div>
                    <!-- <div class="config_tips">设置阈值后，{{ configSetForm.ppg / 60 * configSetForm.normal_rate }}分钟后生效</div> -->
                    <el-button type="info" @click="setConfigDialog = false">取 消</el-button>
                    <el-button type="primary" @click="confirmSetConfig">确 定</el-button>
                </span>
                <span slot="footer" v-else class="dialog-footer">
                    <div class="config_tips">设置阈值及频率后,可通过重启立即更新</div>
                    <!-- <div class="config_tips">设置阈值后，{{ configSetForm.ppg / 60 * configSetForm.normal_rate }}分钟后生效</div> -->
                    <el-button type="primary" @click="confirmConfig">更换阈值</el-button>
                    <el-button type="danger" @click="unbindDevice">解绑</el-button>
                </span>
            </el-dialog>

            <el-dialog :visible.sync="tipsDialog" v-loading="figsLoading" title="设备解绑" width="580px">
                <div class="_tips">
                    <i class="el-icon-warning el-icon-iconName " color="#e6a23c"></i><span>是否将该设备进行解绑</span>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="info" @click="tipsDialog = false">取 消</el-button>
                    <el-button type="primary" @click="setTipsDialog">确 定</el-button>
                </span>
            </el-dialog>
            <SleepDialog :dialogVisible="showSleepDialog" :dialogData="patientInfo" @closeDialog="closeSleepDialog">
            </SleepDialog>
        </div>
        <ActivityInner v-else :patientInfo="patientInfo" @handleBackBtn="handleBackBtnFn"></ActivityInner>

    </div>
</template>

<script>
const checkLow = (rule, value, callback) => {
    setTimeout(() => {
        if (!Number.isInteger(Number(value))) {
            callback(new Error("请输入范围在30-60之间的整数"));
        } else {
            if (value < 30 || value > 60) {
                callback(new Error("请输入范围在30-60之间的整数"));
            } else {
                callback();
            }
        }
    }, 300);
};
const checkHigh = (rule, value, callback) => {
    setTimeout(() => {
        if (!Number.isInteger(Number(value))) {
            console.log(value);
            callback(new Error("请输入范围在80-160之间的整数"));
        } else {
            if (value < 80 || value > 160) {
                callback(new Error("请输入范围在80-160之间的整数"));
            } else {
                callback();
            }
        }
    }, 300);
};
const checkSpo2 = (rule, value, callback) => {
    setTimeout(() => {
        if (!Number.isInteger(Number(value))) {
            callback(new Error("请输入范围在70-99之间的整数"));
        } else {
            if (value < 70 || value > 99) {
                callback(new Error("请输入范围在70-99之间的整数"));
            } else {
                callback();
            }
        }
    }, 300);
};
import ActivityInner from './components/activity_inner.vue';

import SleepDialog from './components/sleepDialog.vue';

export default {
    data() {
        return {
            searchForm: {
                name: '',
            },
            list: [],
            zone_number: '',
            bindVisible: false,
            bindList: [],
            itemData: '',
            repLoading: false,
            configSetForm: {
                high_heartrate_value: 130,
                high_heartrate_time: 10,
                low_heartrate_value: 40,
                low_heartrate_time: 10,
                spo2: 90,
                low_spo_time: 10,
                ppg: 600,
                normal_rate: 6,
            },
            configSetFormRules: {
                high_heartrate_value: [
                    { required: true, message: "请输入心率预警最高值", trigger: "blur" },
                    { validator: checkHigh, trigger: "blur" },
                ],
                low_heartrate_value: [
                    { required: true, message: "请输入心率预警最低值", trigger: "blur" },
                    { validator: checkLow, trigger: "blur" },
                ],
                spo2: [
                    { required: true, message: "请输入血氧预警最低值", trigger: "blur" },
                    { validator: checkSpo2, trigger: "blur" },
                ],
                ppg: [{ required: true, message: "请选择采集频率", trigger: "blur" }],
                normal_rate: [
                    { required: true, message: "请选择上传频率", trigger: "blur" },
                ],
            },
            setConfigDialog: false,
            ppg_list: [
                {
                    label: "5分钟",
                    value: 300,
                },
                {
                    label: "10分钟",
                    value: 600,
                },
            ],
            normal_rate_list_1: [
                {
                    label: "10分钟",
                    value: 2,
                },
                {
                    label: "15分钟",
                    value: 3,
                },
                {
                    label: "20分钟",
                    value: 4,
                },
                {
                    label: "25分钟",
                    value: 5,
                },
                {
                    label: "30分钟",
                    value: 6,
                },
            ],
            normal_rate_list_2: [
                {
                    label: "20分钟",
                    value: 2,
                },
                {
                    label: "30分钟",
                    value: 3,
                },
                {
                    label: "40分钟",
                    value: 4,
                },
                {
                    label: "50分钟",
                    value: 5,
                },
                {
                    label: "60分钟",
                    value: 6,
                },
            ],
            configDisabled: true,
            configDisabledTitle: '设备信息',
            tipsDialog: false,
            figsLoading: false,
            patientInfo: {},
            showActivityDialog: false,
            showSleepDialog: false,
            showInner: false,
            affter: ''
        }
    },
    mounted() {
        this.zone_number = this.$cookies.get("zone_number");
        this.affter = this.$cookies.get("affter");
        this.patient_list()
        this.checkLogin()
    },
    computed:{
         uploadFrequency(){
             let index = this.ppg_list.findIndex(item => item.value == this.configSetForm.ppg);
             if(index>=0){
                     return this.ppg_list[index].label;
             }else{
                     return '10分钟';
             }
         }
    },
    methods: {
        checkLogin() {
            console.log(!this.$cookies.get("token"));
            if (!this.$cookies.get("token")) {
                this.$router.push("/login");
            }
        },
        patient_list() {

            let data = {
                zone_number: this.zone_number,
                name: this.searchForm.name
            }
            this.repLoading = true
            this.$http({
                url: "/api/patient/list",
                method: "GET",
                params: data,
                headers: {
                    Token: this.$cookies.get("token"),
                },
            }).then((res) => {
                console.log('res:', res)
                this.list = res.result;
                this.repLoading = false
            }).catch(err => {
                this.repLoading = false
            })
        },
        search() {
            this.patient_list();
        },
        reset() {
            this.searchForm = {
                name: '',
            }
            this.patient_list();
        },
        bindVisiblebor(item) {
            this.bindList = [];
            this.bindVisible = true;
            this.itemData = item
            this.bind_list();
        },
        //设备绑定列表
        bind_list() {
            this.repLoading = true;
            let data = {
                zone_number: this.zone_number,
            }
            this.$http({
                url: "/api/patient/bind_list",
                method: "GET",
                params: data,
                headers: {
                    Token: this.$cookies.get("token"),
                },
            }).then((res) => {
                console.log('res:', res)
                this.bindList = res.result;
                this.repLoading = false
            }).catch(err => {
                this.repLoading = false
            })
        },
        //绑定
        patient_bind(row) {
            this.repLoading = true;
            let data = {
                zone_number: this.zone_number,
                id: row.id,
                patient_id: this.itemData.patient_id,
                bed_number: this.itemData.bed_number,
            }
            this.$http({
                url: "/api/patient/bind",
                method: "POST",
                data: data,
                headers: {
                    Token: this.$cookies.get("token"),
                },
            }).then((res) => {
                console.log('res:', res)
                this.$message.success('操作成功')
                this.repLoading = false
                this.bindVisible = false
                this.patient_list()
            }).catch(err => {
                this.repLoading = false
                this.bindVisible = false
                this.patient_list()
            })
        },
        yibindVisiblebor(item) {
            this.setConfigDialog = true;
            this.configDisabled = true;
            this.yiitemData = item;
            this.configDisabledTitle = '设备信息'
            this.figsLoading = true;
            //设备信息
            this.$http({
                url: "/api/patient/device",
                method: "GET",
                params: {
                    zone_number: this.zone_number,
                    ccid: item.ccid
                },
                headers: {
                    Token: this.$cookies.get("token"),
                },
            }).then((res) => {
                console.log(res)
                this.configSetForm = res.result
                this.configSetForm.ppg = Number(res.result.ppg)
                this.figsLoading = false;
            }).catch(err => {
                this.setConfigDialog = false;
                this.figsLoading = false;

            })
        },
        confirmConfig() {
            this.configDisabled = false;
            this.configDisabledTitle = '更换阈值'
        },
        //更换阈值
        confirmSetConfig() {
            this.figsLoading = true;
            this.$refs.configSetForm.validate((valid) => {
                if (valid) {
                    let data = Object.assign(
                        { zone_number: this.zone_number },
                        this.configSetForm
                    );
                    console.log('data', data)
                    this.$http({
                        url: "/api/patient/set_config",
                        method: "POST",
                        data: data,
                        headers: {
                            Token: this.$cookies.get("token"),
                            // 'Content-Type':"multipart/form-data"
                        },
                    }).then((res) => {
                        this.$message.success("修改成功");
                        this.setConfigDialog = false;
                        this.figsLoading = false;
                    }).catch(() => {
                        this.setConfigDialog = false;
                        this.figsLoading = false;
                    });
                }
            });
        },
        setTipsDialog() {
            // v-loading="figsLoading"
            this.figsLoading = true;
            let item = this.yiitemData;
            let data = {
                zone_number: this.zone_number,
                patient_id: item.patient_id,
                bed_number: item.bed_number,
            };
            console.log('data', data)
            this.$http({
                url: "/api/patient/out_bind",
                method: "POST",
                data: data,
                headers: {
                    Token: this.$cookies.get("token"),
                },
            }).then((res) => {
                this.$message.success("解绑成功");
                this.tipsDialog = false
                this.figsLoading = false;
                this.patient_list();

            });
        },
        unbindDevice() {

            this.tipsDialog = true;
            this.setConfigDialog = false;

            // this.$confirm("此操作将解绑该设备, 是否继续?", "提示", {
            //     confirmButtonText: "确定",
            //     cancelButtonText: "取消",
            //     type: "warning",
            // })
            //     .then(() => {

            //     })
            //     .catch(() => {
            //         this.$message({
            //             type: "info",
            //             message: "已取消操作",
            //         });
            //     });
        },

        handleActivityDialog(patientInfo) {
            this.patientInfo = patientInfo;
            this.showInner = true;
        },
        handleBackBtnFn() {
            this.showInner = false
        },
        closeActiveDialog() {
            this.showActivityDialog = false;
        },
        handleSleepReport(patientInfo) {
            this.patientInfo = patientInfo;
            this.showSleepDialog = true;
        },
        closeSleepDialog() {
            this.showSleepDialog = false;
        }
    },
    components: {
        ActivityInner, SleepDialog
    }

}
</script>

<style scoped>
.huanz_list {
    display: flex;
    flex-wrap: wrap;

}

.item {
    width: 24%;
    height: 208px;
    border-radius: 12px;
    overflow: hidden;
    margin-left: 1.3%;
    margin-bottom: 24px;
}

.huanz_list .item_l {
    margin-left: 0%;
}

.item .item_title {
    background-color: #3889FF;
    height: 56px;
    line-height: 56px;
    padding-left: 24px;
    padding-right: 24px;
    font-size: 24px;
    color: white;
    /* width: 373px; */
}

.item_title_red {
    background-color: #E24040 !important;
}

.item_box {
    background-color: white;
    height: 152px;
    /* width: 373px; */
    text-align: center;
    padding-top: 20px;
}

.item_name {
    font-size: 48px;
    font-weight: bold;
    margin-bottom: 20px;
}

.item_btn {
    border: 1px solid #3889FF;
    border-radius: 20px;
    width: 104px;
    height: 32px;
    line-height: 32px;
    margin: auto;
    color: #3889FF;
    cursor: pointer;
}

.huanz_list .red {
    color: #E24040;
    border: 1px solid #E24040;
}

._bindList {
    height: 340px;
    overflow-y: scroll;
}

._bindList_text1 {
    color: #3889FF;
}

._bindList_text2 {
    color: #E24040;
}

.set_config_box>>>.el_input {
    width: 140px;
}

.config_type_title {
    color: #252b50;
    font-weight: bold;
    margin-bottom: 12px;
}

.mt_20 {
    margin-top: 20px;
}

.config_tips {
    color: #e24040;
    margin-bottom: 16px;
    font-size: 14px;
}

.set_config_box {
    font-size: 16px;
    padding: 0 24px;
}

._tips {
    height: 146px;
    line-height: 146px;
    color: #e6a23c;
    display: flex;
    align-items: center;
    justify-content: center;
}

._tips span {
    color: #636676;
    margin-left: 5px;
}

.el-icon-iconName {
    font-size: 20px;
}

.report_btn {
    border: 1px solid #fff;
    border-radius: 24px 24px 24px 24px;
    width: 80px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 14px;
    font-family: 'Source Han Sans CN-Bold';
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/view/managePages/huanz_list.vue